/*
 * tool-request.js — wiring for <x-tool-request>, the shared inline
 * "ask us to add X" form. Submissions go to /api/tool-suggestion and land in
 * the /pino/suggestions moderation queue.
 *
 * A tool that drops the component in writes ZERO JavaScript. Everything below
 * used to be copy-pasted per tool (ten of them), which is how fancy-text's
 * version and synonyms' version drifted apart on error handling.
 */
(function () {
    'use strict';

    var MIN_LEN = 3;
    var DEFLECT_MS = 250;
    var DEFLECT_MAX = 6;

    /* "Already here" hook: window.__toolRequestDeflect[slug](text) ->
       [{label, onPick}]. Read at call time, not at mount, so a tool module
       that registers after this script still counts. Anything but a function
       means "no hook", and the form stays exactly as it was. */
    function deflectHook(slug) {
        var reg = window.__toolRequestDeflect;
        var fn = reg && reg[slug];
        return typeof fn === 'function' ? fn : null;
    }

    function clearChips(box) {
        var chips = box.querySelectorAll('[data-tr-chip]');
        for (var i = 0; i < chips.length; i++) {
            if (chips[i].parentNode) chips[i].parentNode.removeChild(chips[i]);
        }
    }

    function showDeflect(box, slug, text) {
        var wrap = box.querySelector('[data-tr-deflect]');
        if (!wrap) return;
        var fn = text.length >= MIN_LEN ? deflectHook(slug) : null;
        var list = null;
        if (fn) {
            try { list = fn(text); } catch (e) { list = null; }
        }
        clearChips(wrap);
        if (!list || !list.length) { wrap.hidden = true; return; }
        var shown = 0;
        for (var i = 0; i < list.length && shown < DEFLECT_MAX; i++) {
            var item = list[i];
            if (!item || !item.label) continue;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'tool-request-chip';
            b.setAttribute('data-tr-chip', '');
            b.textContent = String(item.label);
            b.addEventListener('click', (function (it) {
                return function () {
                    try { if (typeof it.onPick === 'function') it.onPick(); } catch (e) {
                        if (window.__handleError) window.__handleError(e, 'tool-request deflect ' + slug);
                    }
                    try { window.__aeFunnel && window.__aeFunnel('suggest_deflected', { pick: String(it.label).slice(0, 60) }); } catch (_) {}
                };
            })(item));
            wrap.appendChild(b);
            shown++;
        }
        wrap.hidden = shown === 0;
    }

    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }

    function wire(box) {
        if (box.__trWired) return;      // mount is additive — never double-bind
        box.__trWired = true;

        var input = box.querySelector('[data-tr-input]');
        var btn   = box.querySelector('[data-tr-send]');
        var done  = box.querySelector('[data-tr-done]');
        if (!input || !btn) return;

        var slug  = box.getAttribute('data-slug') || '';
        var field = box.getAttribute('data-field') || 'idea';

        btn.addEventListener('click', function () {
            var text = (input.value || '').trim();
            if (text.length < MIN_LEN) { input.focus(); return; }
            btn.disabled = true;

            var payload = { tool_slug: slug, locale: window.__LOCALE || 'en', data: {} };
            payload.data[field] = text;
            // The server snapshots this session's recent events into the row after
            // responding (SuggestionSessionTrace): send the batched ones now, and name
            // the session so the lookup goes through its index.
            try { if (window.__aeFlush) window.__aeFlush(); } catch (_) {}
            try { payload.sid = sessionStorage.getItem('_as') || undefined; } catch (_) {}

            fetch('/api/tool-suggestion', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrf()
                },
                body: JSON.stringify(payload)
            }).then(function (r) {
                if (!r.ok) throw new Error('tool-request HTTP ' + r.status);
                // The form is replaced by the thank-you, not merely disabled:
                // a live textarea after a successful send invites a second
                // submission of the same idea.
                input.style.display = 'none';
                btn.style.display = 'none';
                var dw = box.querySelector('[data-tr-deflect]');
                if (dw) dw.hidden = true;
                if (done) done.hidden = false;
                try { window.__aeFunnel && window.__aeFunnel('tool_request_sent', { slug: slug }); } catch (_) {}
            }).catch(function (err) {
                btn.disabled = false;
                var msg = btn.getAttribute('data-error-text');
                if (window.__toast && msg) window.__toast(msg, 'error');
                if (window.__handleError) window.__handleError(err, 'tool-request ' + slug);
            });
        });

        var deflectTimer = null;
        input.addEventListener('input', function () {
            if (deflectTimer) clearTimeout(deflectTimer);
            deflectTimer = setTimeout(function () {
                deflectTimer = null;
                showDeflect(box, slug, (input.value || '').trim());
            }, DEFLECT_MS);
        });

        // Enter sends when the box is a single line; Shift+Enter always newlines.
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && !e.shiftKey && input.rows <= 1) {
                e.preventDefault();
                btn.click();
            }
        });
    }

    function mount() {
        var boxes = document.querySelectorAll('[data-tool-request]');
        for (var i = 0; i < boxes.length; i++) wire(boxes[i]);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mount);
    } else {
        mount();
    }
})();
